export type InteractionPhase =
  | 'dormant'
  | 'connecting'
  | 'greeting'
  | 'listening'
  | 'recording'
  | 'transcribing'
  | 'thinking'
  | 'conjuring'
  | 'speaking'
  | 'muted'
  | 'error'
  | 'ended';

export function phaseAfterSpeechStart(phase: InteractionPhase, muted: boolean): InteractionPhase {
  if (muted || phase === 'dormant' || phase === 'connecting' || phase === 'ended') return phase;
  return 'recording';
}

export function phaseAfterSpeechEnd(phase: InteractionPhase, hasAudio: boolean): InteractionPhase {
  if (phase !== 'recording') return phase;
  return hasAudio ? 'transcribing' : 'listening';
}

export const PHASE_LABEL: Record<InteractionPhase, string> = {
  dormant: 'Dormant',
  connecting: 'Opening the frame',
  greeting: 'Greeting you',
  listening: 'Listening',
  recording: 'Hearing you',
  transcribing: 'Deciphering your words',
  thinking: 'Considering',
  conjuring: 'Painting the reply',
  speaking: 'Speaking',
  muted: 'Microphone muted',
  error: 'Connection faltered',
  ended: 'Session ended',
};
